






import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/app/HeaderComponent.vue";
@Component({
  name: "main-layout",
  components: {
    HeaderComponent,
  },
})
export default class MainLayout extends Vue {}
